import { FC } from 'react';
import { TransactionFormType } from 'typings/transactionForm';
import useTransactionFormStore from 'global/Securities/stores/useTransactionFormStore';
import useGlobalModalStore from 'global/GlobalModalManager/stores/useGlobalModalStore';
import useFastOrderForm from 'features/fast-order/stores/useFastOrderStore';
import tradingModalStore from 'global/TradingModal/store';
import { GlobalModalType } from 'global/GlobalModalManager/types';
import useTradingStore from 'features/transaction/useTradingStore';
import { ItemWrapper, SelectForm } from './styled';

interface FormTypeSelectProps {
  onChange?: (value: TransactionFormType) => void;
}

export const CircleCheck = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="6" fill="currentColor" />
    <path
      d="M5.59961 7.99844L6.73016 9.2232C6.92026 9.42914 7.24249 9.43863 7.44438 9.24422L10.3996 6.39844"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const FormTypeSelect: FC<FormTypeSelectProps> = ({ onChange }) => {
  const [showTabs, showOrderbook] = tradingModalStore((s) => [
    s.showTabs,
    s.showOrderbook,
  ]);
  const orderType = useTradingStore((s) => s.orderType);
  const classicSymbol = useTradingStore((s) => s.symbol);
  const [formType, setFormType] = useTransactionFormStore((s) => [
    s.formType,
    s.setFormType,
  ]);
  const setSymbol = useFastOrderForm((s) => s.setSymbol);

  const [setActiveModal] = useGlobalModalStore((s) => [s.setActiveModal]);

  const handleSelectChange = (value: TransactionFormType) => {
    setSymbol(classicSymbol); // Update symbol used by classic form to fast order form
    setFormType(value);
    setActiveModal(GlobalModalType.FastOrder, {
      switchFormConfig: { orderType, showTabs, showOrderbook },
    });
    onChange(value);
  };

  return (
    <SelectForm
      className="hide-icon"
      value={formType}
      onChange={handleSelectChange}
      options={[
        {
          label: (
            <ItemWrapper>
              Classic
              {formType === TransactionFormType.Classic && (
                <span>
                  <CircleCheck />
                </span>
              )}
            </ItemWrapper>
          ),
          value: TransactionFormType.Classic,
        },
        {
          label: (
            <ItemWrapper>
              Fast Order
              {formType === TransactionFormType.FastOrder && (
                <span>
                  <CircleCheck />
                </span>
              )}
            </ItemWrapper>
          ),
          value: TransactionFormType.FastOrder,
        },
      ]}
    />
  );
};

export default FormTypeSelect;
